import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/MainPage/Header';
import Banner from './components/MainPage/Banner';
import CourseSection from './components/MainPage/CourseSection';
import Footer from './components/MainPage/Footer';
import CourseDetailPage from './components/CourseDetailPage';
import ClassDetailPage from './components/ClassDetailPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Banner />
              <CourseSection title="优选课程" description="在您课程的旅程，我们陪伴成长！" type="featured" />
              <CourseSection title="优选班级" description="物以类聚，人以群分，课程以班级分。" type="unity" />
              <CourseSection title="学院动态" description="学习时的苦痛是暂时的，未学到的痛苦是终生的。" type="comments" />
            </>
          } />
          <Route path="/course/:courseId" element={<CourseDetailPage />} />
          <Route path="/class/:classId" element={<ClassDetailPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 